import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { transformLifeAreaSectionToGoal } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export type TransformLifeAreaSectionToGoalMutationOptions = {
  lifeArea: LifeArea;
  sectionId: ID;
};

export const useTransformLifeAreaSectionToGoalMutation = () => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      lifeArea,
      sectionId,
    }: TransformLifeAreaSectionToGoalMutationOptions) =>
      transformLifeAreaSectionToGoal(
        sectionId,
        lifeArea,
        t('general.untitled-goal'),
      ),
  });
};
